/** Per-training shareable links. */
export function buildShareUrl(session) {
  if (!session) return "";
  const slug = session.slug || "training";
  return `${window.location.origin}/trainings/${slug}?id=${session.id}`;
}

export function buildWhatsappHref(session, url) {
  const link = url || buildShareUrl(session);
  const title = session?.title || "Free CP training";
  const msg = `Yeh free CP training miss mat karo — "${title}". Join ya book yahan: ${link}`;
  return `https://wa.me/?text=${encodeURIComponent(msg)}`;
}
